<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field label="Nome" solo v-model="query" @click:append="search()" append-icon="mdi-magnify" v-on:keyup.enter="search()" dense></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ current.length }} registros encontrados
        </v-alert>
      </v-col>
      <v-col cols="12" sm="2">
        <v-btn color="primary" @click="register()" block>+</v-btn>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.name }}</td>
          <td><v-btn icon :to="'/plan/' + item.id"><v-icon>mdi-magnify</v-icon></v-btn></td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: () => ({
    current: null,
    query: ""
  }),
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/plan", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.current = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
    },
    details: function(item) {
      router.push({ path: `/plan/${item.id}` });
    },
    register: function (){
      router.push({path: "/plan/new"});
    },
    search: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/plan/name/"+this.query, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>